import { BaseElement } from '@theme/base-element'
import { html } from '@theme/vendor-lit'

const QUICKSHOP_EVENTS = {
  OPEN: 'quickshop::open',
}

export class QuickShop extends BaseElement {
  static get properties() {
    return {
      productUrl: { type: String, attribute: 'product-url' },
    }
  }

  handleClick(event) {
    event.preventDefault()
    let url = this.productUrl
    if (url.includes('?')) {
      url = `${url}&view=quick-shop&layout=none`
    } else {
      url = `${url}?view=quick-shop&layout=none`
    }

    this.$emit(QUICKSHOP_EVENTS.OPEN, url)
  }

  render() {
    return html`<slot @click="${this.handleClick}"></slot>`
  }
}

customElements.define('quick-shop-toggle', QuickShop)
